import { DeleteSystemLogoRequestSchema, DeleteSystemLogoResponseSchema } from './delete-system-logo.schema';
/**
 * Delete System Logo Endpoint Contract
 * Removes system's logo
 */ export const deleteSystemLogoContract = {
    method: 'DELETE',
    path: '/api/v2/system-logo/:systemId',
    description: 'Delete system logo',
    requestSchema: DeleteSystemLogoRequestSchema,
    responseSchema: DeleteSystemLogoResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - invalid or missing token',
            404: 'System not found',
            500: 'Internal server error'
        }
    }
};

//# sourceMappingURL=delete-system-logo.contract.js.map